import {Box} from '@mui/material';
import React from 'react';

interface TabPanelProps {
   children?: React.ReactNode;
   index: any;
   value: any;
   prefix?: string;
   className?: string;
}

export function a11yProps(index: any, prefix?: string) {
   return {
      id: `${prefix}-tab-${index}`,
      'aria-controls': `${prefix}-tabpanel-${index}`,
   };
}

export function TabPanel(props: TabPanelProps) {
   const {children, value, index, prefix, ...other} = props;

   return (
      <div
         role="tabpanel"
         hidden={value !== index}
         id={`${prefix}-tabpanel-${index}`}
         aria-labelledby={`${prefix}-tab-${index}`}
         {...other}
      >
         {value === index && <Box pl={2}>{children}</Box>}
      </div>
   );
}
